<template>
  <div class="family-contact">
    <div>
      <div v-if="!!family.length" class="contact-list">
        <div class="md-layout" v-for="(contact, idx) in family" :key="idx">
          <div class="md-layout-item md-size-95 md-small-size-100 p-0">
            <div class="contact-info border border-gray-400 md-layout py-8">
              <!-- USERNAME -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.username") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.username"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- USERNAME -->

              <!-- SEX -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.sex") }}</label>
                  <md-select name="sex" v-model.trim="contact.sex" disabled>
                    <md-option value="Male">{{ $t("student.male") }}</md-option>
                    <md-option value="Female">{{
                      $t("student.female")
                    }}</md-option>
                    <md-option value="Other">{{
                      $t("common.other")
                    }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- SEX -->

              <!-- First name -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.first_name") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.first_name"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- First name -->

              <!-- Middle name -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.middle_name") }}</label>
                  <md-input
                    v-model.trim="contact.middle_name"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- Middle name -->

              <!-- Last name -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.last_name") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.last_name"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- Last name -->

              <!-- STATUS -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.status") }}</label>
                  <md-select
                    name="status"
                    required
                    v-model.trim="contact.status"
                    disabled
                  >
                    <md-option value="Active">{{
                      $t("common.active")
                    }}</md-option>
                    <md-option value="Inactive">{{
                      $t("common.inactive")
                    }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- STATUS -->

              <!-- EMAIL -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.email") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.email"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- EMAIL -->

              <!-- PHONE_NUMBER -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.phone_number") }}</label>
                  <md-input
                    v-model.trim="contact.phone_number"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- PHONE_NUMBER -->

              <!-- RELATIONSHIP -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.relationship") }}</label>
                  <md-input
                    v-model.trim="contact.relationship"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <!-- RELATIONSHIP -->

              <!-- Account contact-->
              <p class="md-layout-item md-size-100">
                {{ $t("student.account_address") }}
              </p>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-radio
                  disabled
                  v-model.trim="contact.type_account_address"
                  :value="typeAddress.primaryAddress"
                  ><span class="text-gray-800">{{
                    $t("student.same_to_child_primary_address")
                  }}</span>
                </md-radio>
              </div>
              <div class="md-layout-item md-size-35 md-small-size-100">
                <md-radio
                  disabled
                  v-model.trim="contact.type_account_address"
                  :value="typeAddress.secondaryAddress"
                  ><span class="text-gray-800">{{
                    $t("student.same_to_child_secondary_address")
                  }}</span></md-radio
                >
              </div>
              <div class="md-layout-item md-size-32 md-small-size-100">
                <md-radio
                  disabled
                  v-model.trim="contact.type_account_address"
                  :value="typeAddress.other"
                >
                  <span class="text-gray-800">{{
                    $t("common.other")
                  }}</span></md-radio
                >
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.street") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.street"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.apartment") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.apartment"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.city") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.city"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.country") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.country"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.state") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.state"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.zip") }}</label>
                  <md-input
                    disabled
                    v-model.trim="contact.form_account_address.zip"
                  ></md-input>
                </md-field>
              </div>
            </div>
          </div>
          <div
            class="md-layout-item md-size-5 flex lg:flex-col justify-center items-center m-auto"
          >
            <md-button
              v-if="canEdit || isParent"
              class="md-simple md-just-icon md-icon-button md-success"
              :data-contact-idx="idx"
              @click.native.prevent="() => showEditContactModal(idx)"
            >
              <md-icon>mode_edit</md-icon>
            </md-button>

            <md-button
              v-if="canEdit || isParent"
              class="md-simple md-just-icon md-icon-button md-danger"
              @click.native.prevent="() => confirmDeleteContact(idx)"
            >
              <md-icon>delete_forever</md-icon>
            </md-button>
          </div>
        </div>
      </div>

      <div v-else class="empty-list text-center leading-7 mb-4">
        <p class="text-base text-gray-700 font-medium">
          {{ $t("student.the_contact_list_is_empty") }}
        </p>
      </div>

      <div
        class="md-layout-item md-size-100 text-center"
        v-if="family.length < 2"
      >
        <md-button
          v-if="canEdit || isParent"
          class="md-success mt-1"
          @click.prevent="showAddContactModal"
          >{{ $t("student.add_new_contact") }}</md-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { getId, Message } from "@/helpers/utils";
import { service_names, service_paths } from "@/constants/Services";
import { hasValidRole } from "../../../../helpers/role-helper";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import KeycloakLib from "@/libs/Keycloak";
import { store } from "@/store";
import { removeDeviceToken } from "@/helpers/firebase";

const typeAddress = () => ({
  primaryAddress: "primary_address",
  secondaryAddress: "secondary_address",
  other: "other"
});
export default {
  name: "family",
  data() {
    return {
      family: [],
      typeAddress: typeAddress()
    };
  },
  props: ["canEdit"],
  inject: ["fetchStudentData", "showContactModal"],
  computed: {
    studentId() {
      return this.$route.params.id;
    },
    ...mapGetters("user", ["role", "info"]),
    isParent() {
      return hasValidRole(this.role, [Role.Family]);
    }
  },
  methods: {
    fetchDataFamily(studentId) {
      this.family = [];
      this.$axios
        .get(`${service_paths.families}/students/${studentId}`)
        .then(response => {
          response.data.map(family => {
            if (family.parent?.user_no_sql) {
              if (!family.parent.user_no_sql.form_account_address) {
                family.parent.user_no_sql.form_account_address = {};
              }
              this.family.push(family.parent.user_no_sql);
            }
          });
        });
    },

    showAddContactModal() {
      this.showContactModal({ mode: "add" });
    },

    showEditContactModal(idx) {
      const contact = this.family[idx];
      this.showContactModal({ mode: "edit", contact });
    },

    confirmDeleteContact(idx) {
      const contact = this.family[idx];
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.you_wont_be_able_to_revert_this"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteContact(contact);
          if (getId(this.info) === getId(contact)) {
            store.dispatch("chat/clearInfoChat");
            removeDeviceToken();
            KeycloakLib.doLogout();
            store.dispatch("schoolAuth/Logout");
          }
        }
      });
    },

    deleteContact(contact) {
      this.$axios
        .delete(
          `${service_names.user}/families/${contact._id}/student/${this.studentId}/delete`
        )
        .then(() => {
          this.fetchStudentData();
          Message.success(this.$t("common.delete_success"));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sibling-desc {
  &::after {
    border-bottom: none !important;
  }
}

.isis-textarea {
  font-size: 12px !important;
  resize: none;
  &.md-focused {
    &::after {
      display: none;
    }
  }

  &::-webkit-input-placeholder {
    font-size: 12px;
  }
}

.md-button .md-button-content i {
  font-size: 28px !important;
}
</style>
